export default __webpack_public_path__ + "static/lutein-prevantivno-borovinki-bilberry-45694f2d1da6b95123a0116f3d55719e.jpg";